import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(protected)/layout.tsx");
